/**
 * @ngdoc service
 * @name CommonUtils.browserDetect
 */
export default function ($window) {
    'ngInject';

    this.getBrowserPrefix = () => {
        const browser = this.getBrowser();

        if (browser === 'Safari' || browser === 'Chrome') {
            return 'webkit';
        }
        if (browser === 'IE' || browser === 'Edge') {
            return 'MS';
        }
        if (browser === 'Firefox') {
            return 'moz';
        }
        return '';
    };

    this.getBrowser = () => {
        const userAgent = $window.navigator.userAgent;
        if (userAgent.match(/trident|msie/i)) {
            return 'IE';
        }
        if (userAgent.includes('Edge')) {
            return 'Edge';
        }
        if (userAgent.includes('Safari') && !userAgent.includes('Chrome')) {
            return 'Safari';
        }
        if (userAgent.includes('Chrome')) {
            return 'Chrome';
        }
        if (userAgent.includes('Firefox')) {
            return 'Firefox';
        }
        return '';
    };
}



// WEBPACK FOOTER //
// ./src/js/services/browserDetectService.js